<template>
    <div>
        <h3>Home</h3>
        <dl>
            <dt>Team Name</dt>
            <dd>{{ this.name }}</dd>
            <dt>Your Team URL</dt>
            <dd>https://www.bitscheduler.com/home/{{ this.teamKey }}</dd>
        </dl>
    </div>
</template>

<script>
export default {
    props: {
        name: String,
        teamKey: String
    }
}
</script>

<style>
</style>
